/*
  Sakura Stash: header dropdowns open on hover (header-menu.js) and must close as soon as the shopper moves
  away or scrolls the page. The theme closes them on pointerleave, but that never fires when the page scrolls
  under a still pointer, so the menu could stay open. Close it on scroll and whenever the pointer is anywhere
  outside the header.
*/
(() => {
  const openMenu = () => {
    const menu = document.querySelector('header-menu');
    return menu && menu.getAttribute('aria-expanded') === 'true' ? menu : null;
  };

  const close = () => {
    const menu = openMenu();
    if (!menu) return;

    const header = menu.closest('header-component') || menu;
    if (header.matches(':hover')) return;

    // Each menu item closes its dropdown on pointerleave (see header-menu.js deactivate)
    menu.querySelectorAll('.menu-list__list-item').forEach((item) => {
      item.dispatchEvent(new PointerEvent('pointerleave', { bubbles: false }));
    });
  };

  window.addEventListener('scroll', close, { passive: true });

  document.addEventListener(
    'pointerover',
    (event) => {
      const menu = openMenu();
      if (!menu) return;
      const header = menu.closest('header-component') || menu;
      if (!header.contains(/** @type {Node} */ (event.target))) close();
    },
    { passive: true }
  );
})();
